module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div id="widget_header_region"></div>\n<div id="interactive_region"></div>\n';
 if (checkSkipContentLinks()) { ;
__p += '\n    <a class="screen_reader_only screen_reader_only_focus_visible skip_content_link" href="#gallery_end" id="gallery_start">' +
((__t = ( I18n.t('widget.screen_reader_only.gallery.skip_to_end') )) == null ? '' : __t) +
'</a>\n';
 } ;
__p += '\n<div id="mosaic_widget" class="wrap">\n    <div class="mosaic_frame">\n    </div>\n    <div id="mosaic_control" class="controls">\n        <button class="load_more">' +
((__t = ( I18n.t('widget.load_more') )) == null ? '' : __t) +
'</button>\n    </div>\n</div>\n';
 if (checkSkipContentLinks()) { ;
__p += '\n    <a class="screen_reader_only screen_reader_only_focus_visible skip_content_link skip_content_link_end" href="#gallery_start" id="gallery_end">' +
((__t = ( I18n.t('widget.screen_reader_only.gallery.skip_to_beginning') )) == null ? '' : __t) +
'</a>\n';
 } ;
__p += '\n';

}
return __p
}